import React from 'react';

export const IsHomepageContext = React.createContext<boolean>(false);
